import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

import {
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL,
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE,
  GENERATE_R2R_CHART,
  GENERATE_R2R_CHART_SUCCESS,
  GENERATE_R2R_CHART_FAILURE,
} from './types';
import {
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  generateR2RChart as generateR2RChartApi,
  fetchCategoriesWithTags as fetchCategoriesWithTagsApi,
  fetchTags as fetchTagsApi,
  fetchTLSAccounts as fetchAccountsApi,
} from '../api';
import fixDataTypesProcessor from '../xlsxImport/processors/fixDataTypes.processor';

import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import { excelOptionsSelector } from './selectors';

export const sharedActions = getActions(adminPageNames.TLS_ACCOUNTS, {
  pageTitle: adminPageTitles.TLS_ACCOUNTS,
  api: getApi({
    pageTitle: adminPageTitles.TLS_ACCOUNTS,
    endpoints: {
      FETCH: Config.endpoints.FETCH_TLS_ACCOUNTS,
      INSERT: Config.endpoints.ADD_TLS_ACCOUNT,
      UPDATE: Config.endpoints.UPDATE_TLS_ACCOUNT,
      DELETE: Config.endpoints.DELETE_TLS_ACCOUNT,
      VALIDATE: Config.endpoints.VALIDATE_TLS_ACCOUNT,
      IMPORT: Config.endpoints.IMPORT_TLS_ACCOUNT,
    },
  }),
  sortingField: 'account',
  agGridConfig: agGridConfig.adminTLSAccounts,
  excel: {
    sheetName: 'TLS Accounts',
    readXlsxFileAsJsonOptionsSelector: excelOptionsSelector,
    dataTypesProcessor: fixDataTypesProcessor,
  },
});

export const fetchInitialDataForTLSAccountModal = ({ periodName }) => async dispatch => {
  dispatch({ type: FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL });
  try {
    const [
      enabledFlagValues,
      categoriesWithTags,
      tags,
      tlsAccounts,
    ] = await Promise.all([
      fetchEnabledFlagValuesApi(),
      fetchCategoriesWithTagsApi(periodName),
      fetchTagsApi(periodName),
      fetchAccountsApi(periodName),
    ]);

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS,
      enabledFlagValues,
      categoriesWithTags,
      tags,
      tlsAccounts,
    });
  } catch (error) {
    dispatch({ type: FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const generateR2RChart = () => async ( dispatch, getState ) => {
  dispatch({
    type: GENERATE_R2R_CHART,
  });
  try {
    await generateR2RChartApi(getState().shared.currentPeriod.name);

    dispatch(successNotification('Generate R2R chart completed'));
    dispatch({
      type: GENERATE_R2R_CHART_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: GENERATE_R2R_CHART_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};
